import { useContext, useEffect } from "react";
import { CadviewerContext } from "../../../context/Cadviewer.Context";
import { AIChatV4, useAIChatStoreV4 } from "../stores/aiChatStoreV4";
import { ChatMessageV4, ChatSuccessResponseV4 } from "../types/aiChatClientV4";

export interface UseAIChatV4ReturnType {
  messages: ChatMessageV4[];
  isLoading: boolean;
  isSearching: boolean;
  error: string | null;
  sendMessage: (prompt: string) => Promise<void>;
  currentSearchResult: ChatSuccessResponseV4 | null;
  clearError: () => void;
  clearHistoryMessagesToSend: () => void;
  internalCADViewerAICallback: (chatMessage: ChatMessageV4) => void;
  currentHighlight: string | null;
  clearCurrentHighlight: () => void;
}

export function useAIChatV4(): UseAIChatV4ReturnType {
  const { plansInfo, distanceData, selectedPlan, selectedPlanDetail } = useContext(CadviewerContext);
  const spacesNames =
    plansInfo?.spaces.map((space) => ({
      name: space.spaceHeader,
      dbas: [],
    })) || [];

  // Utiliser directement les propriétés du store avec destructuring
  const messages = useAIChatStoreV4((state: AIChatV4) => state.messages);
  const isLoading = useAIChatStoreV4((state: AIChatV4) => state.isLoading);
  const isSearching = useAIChatStoreV4((state: AIChatV4) => state.isSearching);
  const error = useAIChatStoreV4((state: AIChatV4) => state.error);
  const currentSearchResult = useAIChatStoreV4(
    (state: AIChatV4) => state.currentSearchResult
  );
  const currentHighlight = useAIChatStoreV4(
    (state: AIChatV4) => state.currentHighlight
  );
  const clearCurrentHighlight = useAIChatStoreV4(
    (state: AIChatV4) => state.clearCurrentHighlight
  );
  const sendMessage = useAIChatStoreV4((state: AIChatV4) => state.sendMessage);
  const mockSendMessage = async (
    prompt: string,
    useGlobalMode: boolean = false,
    selectedSpaces?: string[]
  ) => {
    await sendMessage(
      prompt,
      spacesNames,
      selectedPlan,
      selectedPlanDetail,
      useGlobalMode,
      selectedSpaces
    );
  };
  const clearError = useAIChatStoreV4((state: AIChatV4) => state.clearError);
  const clearHistoryMessagesToSend = useAIChatStoreV4(
    (state: AIChatV4) => state.clearHistoryMessagesToSend
  );
  const internalCADViewerAICallback = useAIChatStoreV4(
    (state: AIChatV4) => state.internalCADViewerAICallback
  );
  const setPlansInfoAndDistanceData = useAIChatStoreV4(
    (state: AIChatV4) => state.setPlansInfoAndDistanceData
  );

  // Synchroniser les données du context avec le store
  useEffect(() => {
    setPlansInfoAndDistanceData(plansInfo, distanceData);
  }, [plansInfo, distanceData, setPlansInfoAndDistanceData]);

  return {
    messages,
    isLoading,
    isSearching,
    error,
    sendMessage: mockSendMessage,
    currentSearchResult,
    clearError,
    clearHistoryMessagesToSend,
    internalCADViewerAICallback,
    currentHighlight,
    clearCurrentHighlight,
  };
}
